export default __webpack_public_path__ + "static/media/ReleaseNotes_Privacy_Policy.0003a440.png";